import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { cookieStatus } from '../../store/actions/app.action';

export default () => {
  const dispatch = useDispatch();

  useEffect(() => {
    let isEnabled;

    if (navigator.cookieEnabled) {
      isEnabled = true;
    } else {
      // Set and read cookie
      document.cookie = '__TEST_COOKIE__=1';
      isEnabled = document.cookie.indexOf('__TEST_COOKIE__') !== -1;

      // Delete cookie
      document.cookie =
        '__TEST_COOKIE__=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
    }

    dispatch(cookieStatus(isEnabled));
  }, []);
};
